import type { MeasurerTypeType } from '@/types/domain/sleep/valueObjects/measurerType';

import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 測定タイプ
 */
export class MeasurerType extends PrimitiveValueObject<MeasurerTypeType> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: MeasurerTypeType): MeasurerType {
    return new MeasurerType(value);
  }
}
